// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__36j7U","content":"ManualTimeModal_content__34-t4"};